export type Color = {
  id: string;
  label?: string;
  value: string;
  subGroupId?: string;
};

export type ColorGroups = {
  id: string;
  label: string;
  colors: Color[];
  subGroups?: { id: string; label: string; hideDivider?: boolean; className?: string }[];
};

//to generate the unique color ids as earlier we used to save palette- prefix in the id
const ALL_UNIQUE_COLOR_IDS: string[] = [
  // From whiteBlack
  'bg-transparent',
  'bg-primary',
  'bg-primary_inverse',

  // From primaryColor (note: 'bg-secondary' appears twice but we only include once)
  'bg-solid-secondary',
  'bg-overlay',
  'bg-darker',
  'bg-dark',
  'bg-strong',
  'bg-medium',
  'bg-mild',
  'bg-quaternary',
  'bg-tertiary',
  'bg-secondary',
  'bg-lightest',
  'bg-brand-solid',
  'bg-brand-darkest',
  'bg-brand-darker',
  'bg-utility-brand-800',
  'bg-utility-brand-700',
  'bg-brand-medium',
  'bg-brand-mild',
  'bg-brand-soft',
  'bg-brand-tertiary',
  'bg-brand-secondary',
  'bg-brand-primary',
  'bg-utility-brand-25',
  'bg-palette-brand-secondary-600',
  'bg-palette-brand-secondary-950',
  'bg-palette-brand-secondary-900',
  'bg-palette-brand-secondary-800',
  'bg-palette-brand-secondary-700',
  'bg-palette-brand-secondary-500',
  'bg-palette-brand-secondary-400',
  'bg-palette-brand-secondary-300',
  'bg-palette-brand-secondary-200',
  'bg-palette-brand-secondary-100',
  'bg-palette-brand-secondary-50',
  'bg-palette-brand-secondary-25',
  'bg-palette-success-600',
  'bg-palette-success-950',
  'bg-palette-success-900',
  'bg-palette-success-800',
  'bg-palette-success-700',
  'bg-palette-success-500',
  'bg-palette-success-400',
  'bg-palette-success-300',
  'bg-palette-success-200',
  'bg-palette-success-100',
  'bg-palette-success-50',
  'bg-palette-success-25',
  'bg-palette-error-600',
  'bg-palette-error-950',
  'bg-palette-error-900',
  'bg-palette-error-800',
  'bg-palette-error-700',
  'bg-palette-error-500',
  'bg-palette-error-400',
  'bg-palette-error-300',
  'bg-palette-error-200',
  'bg-palette-error-100',
  'bg-palette-error-50',
  'bg-palette-error-25',
  'bg-palette-warning-600',
  'bg-palette-warning-950',
  'bg-palette-warning-900',
  'bg-palette-warning-800',
  'bg-palette-warning-700',
  'bg-palette-warning-500',
  'bg-palette-warning-400',
  'bg-palette-warning-300',
  'bg-palette-warning-200',
  'bg-palette-warning-100',
  'bg-palette-warning-50',
  'bg-palette-warning-25',

  // From accentColors
  'bg-palette-lime-green-600',
  'bg-palette-lime-green-950',
  'bg-palette-lime-green-900',
  'bg-palette-lime-green-800',
  'bg-palette-lime-green-700',
  'bg-palette-lime-green-500',
  'bg-palette-lime-green-400',
  'bg-palette-lime-green-300',
  'bg-palette-lime-green-200',
  'bg-palette-lime-green-100',
  'bg-palette-lime-green-50',
  'bg-palette-lime-green-25',
  'bg-palette-teal-600',
  'bg-palette-teal-950',
  'bg-palette-teal-900',
  'bg-palette-teal-800',
  'bg-palette-teal-700',
  'bg-palette-teal-500',
  'bg-palette-teal-400',
  'bg-palette-teal-300',
  'bg-palette-teal-200',
  'bg-palette-teal-100',
  'bg-palette-teal-50',
  'bg-palette-teal-25',
  'bg-palette-cyan-600',
  'bg-palette-cyan-950',
  'bg-palette-cyan-900',
  'bg-palette-cyan-800',
  'bg-palette-cyan-700',
  'bg-palette-cyan-500',
  'bg-palette-cyan-400',
  'bg-palette-cyan-300',
  'bg-palette-cyan-200',
  'bg-palette-cyan-100',
  'bg-palette-cyan-50',
  'bg-palette-cyan-25',
  'bg-palette-blue-600',
  'bg-palette-blue-950',
  'bg-palette-blue-900',
  'bg-palette-blue-800',
  'bg-palette-blue-700',
  'bg-palette-blue-500',
  'bg-palette-blue-400',
  'bg-palette-blue-300',
  'bg-palette-blue-200',
  'bg-palette-blue-100',
  'bg-palette-blue-50',
  'bg-palette-blue-25',
  'bg-palette-blue-dark-600',
  'bg-palette-blue-dark-950',
  'bg-palette-blue-dark-900',
  'bg-palette-blue-dark-800',
  'bg-palette-blue-dark-700',
  'bg-palette-blue-dark-500',
  'bg-palette-blue-dark-400',
  'bg-palette-blue-dark-300',
  'bg-palette-blue-dark-200',
  'bg-palette-blue-dark-100',
  'bg-palette-blue-dark-50',
  'bg-palette-blue-dark-25',
  'bg-palette-indigo-600',
  'bg-palette-indigo-950',
  'bg-palette-indigo-900',
  'bg-palette-indigo-800',
  'bg-palette-indigo-700',
  'bg-palette-indigo-500',
  'bg-palette-indigo-400',
  'bg-palette-indigo-300',
  'bg-palette-indigo-200',
  'bg-palette-indigo-100',
  'bg-palette-indigo-50',
  'bg-palette-indigo-25',
  'bg-palette-violet-600',
  'bg-palette-violet-950',
  'bg-palette-violet-900',
  'bg-palette-violet-800',
  'bg-palette-violet-700',
  'bg-palette-violet-500',
  'bg-palette-violet-400',
  'bg-palette-violet-300',
  'bg-palette-violet-200',
  'bg-palette-violet-100',
  'bg-palette-violet-50',
  'bg-palette-violet-25',
  'bg-palette-fuchsia-600',
  'bg-palette-fuchsia-950',
  'bg-palette-fuchsia-900',
  'bg-palette-fuchsia-800',
  'bg-palette-fuchsia-700',
  'bg-palette-fuchsia-500',
  'bg-palette-fuchsia-400',
  'bg-palette-fuchsia-300',
  'bg-palette-fuchsia-200',
  'bg-palette-fuchsia-100',
  'bg-palette-fuchsia-50',
  'bg-palette-fuchsia-25',
  'bg-palette-pink-600',
  'bg-palette-pink-950',
  'bg-palette-pink-900',
  'bg-palette-pink-800',
  'bg-palette-pink-700',
  'bg-palette-pink-500',
  'bg-palette-pink-400',
  'bg-palette-pink-300',
  'bg-palette-pink-200',
  'bg-palette-pink-100',
  'bg-palette-pink-50',
  'bg-palette-pink-25',
  'bg-palette-rose-600',
  'bg-palette-rose-950',
  'bg-palette-rose-900',
  'bg-palette-rose-800',
  'bg-palette-rose-700',
  'bg-palette-rose-500',
  'bg-palette-rose-400',
  'bg-palette-rose-300',
  'bg-palette-rose-200',
  'bg-palette-rose-100',
  'bg-palette-rose-50',
  'bg-palette-rose-25',
  'bg-palette-orange-600',
  'bg-palette-orange-950',
  'bg-palette-orange-900',
  'bg-palette-orange-800',
  'bg-palette-orange-700',
  'bg-palette-orange-500',
  'bg-palette-orange-400',
  'bg-palette-orange-300',
  'bg-palette-orange-200',
  'bg-palette-orange-100',
  'bg-palette-orange-50',
  'bg-palette-orange-25',
];

export const whiteBlack = [
  {
    id: 'bg-transparent',
    value: 'transparent',
    label: 'Transparent',
  },
  { id: 'bg-primary', value: '--bg-primary', label: 'White' },
  { id: 'bg-primary_inverse', value: '--bg-primary_inverse', label: 'Black' },
];

export const primaryColor = [
  // gray colors
  { id: 'bg-solid-tertiary', value: '--bg-solid-tertiary', label: 'Gray 600' },
  { id: 'bg-overlay', value: '--bg-overlay', label: 'Gray 950' },
  { id: 'bg-darker', value: '--bg-darker', label: 'Gray 900' },
  { id: 'bg-solid-secondary', value: '--bg-solid-secondary', label: 'Gray 800' },
  { id: 'bg-strong', value: '--bg-strong', label: 'Gray 700' },
  { id: 'bg-medium', value: '--bg-medium', label: 'Gray 500' },
  { id: 'bg-mild', value: '--bg-mild', label: 'Gray 400' },
  { id: 'bg-soft', value: '--bg-soft', label: 'Gray 300' },
  { id: 'bg-softer', value: '--bg-softer', label: 'Gray 200' },
  { id: 'bg-quaternary', value: '--bg-quaternary', label: 'Gray 100' },
  { id: 'bg-tertiary', value: '--bg-tertiary', label: 'Gray 50' },
  { id: 'bg-secondary', value: '--bg-secondary', label: 'Gray 25' },

  // brand colors
  { id: 'bg-brand-solid', value: '--bg-brand-solid', label: 'Brand 600' },
  { id: 'bg-brand-darkest', value: '--bg-brand-darkest', label: 'Brand 950' },
  { id: 'bg-brand-darker', value: '--bg-brand-darker', label: 'Brand 900' },
  { id: 'bg-brand-dark', value: '--bg-brand-dark', label: 'Brand 800' },
  { id: 'bg-brand-strong', value: '--bg-brand-strong', label: 'Brand 700' },
  { id: 'bg-brand-medium', value: '--bg-brand-medium', label: 'Brand 500' },
  { id: 'bg-brand-mild', value: '--bg-brand-mild', label: 'Brand 400' },
  { id: 'bg-brand-soft', value: '--bg-brand-soft', label: 'Brand 300' },
  { id: 'bg-brand-softer', value: '--bg-brand-softer', label: 'Brand 200' },
  { id: 'bg-brand-tertiary', value: '--bg-brand-tertiary', label: 'Brand 100' },
  { id: 'bg-brand-secondary', value: '--bg-brand-secondary', label: 'Brand 50' },
  { id: 'bg-brand-primary', value: '--bg-brand-primary', label: 'Brand 25' },

  // brand secondary colors
  {
    id: 'bg-palette-brand-secondary-600',
    value: '--palette-brand-secondary-600',
    label: 'Brand Secondary 600',
  },
  {
    id: 'bg-palette-brand-secondary-950',
    value: '--palette-brand-secondary-950',
    label: 'Brand Secondary 950',
  },
  {
    id: 'bg-palette-brand-secondary-900',
    value: '--palette-brand-secondary-900',
    label: 'Brand Secondary 900',
  },
  {
    id: 'bg-palette-brand-secondary-800',
    value: '--palette-brand-secondary-800',
    label: 'Brand Secondary 800',
  },
  {
    id: 'bg-palette-brand-secondary-700',
    value: '--palette-brand-secondary-700',
    label: 'Brand Secondary 700',
  },
  {
    id: 'bg-palette-brand-secondary-500',
    value: '--palette-brand-secondary-500',
    label: 'Brand Secondary 500',
  },
  {
    id: 'bg-palette-brand-secondary-400',
    value: '--palette-brand-secondary-400',
    label: 'Brand Secondary 400',
  },
  {
    id: 'bg-palette-brand-secondary-300',
    value: '--palette-brand-secondary-300',
    label: 'Brand Secondary 300',
  },
  {
    id: 'bg-palette-brand-secondary-200',
    value: '--palette-brand-secondary-200',
    label: 'Brand Secondary 200',
  },
  {
    id: 'bg-palette-brand-secondary-100',
    value: '--palette-brand-secondary-100',
    label: 'Brand Secondary 100',
  },
  {
    id: 'bg-palette-brand-secondary-50',
    value: '--palette-brand-secondary-50',
    label: 'Brand Secondary 50',
  },
  {
    id: 'bg-palette-brand-secondary-25',
    value: '--palette-brand-secondary-25',
    label: 'Brand Secondary 25',
  },

  //success
  { id: 'bg-utility-success-600', value: '--utility-success-600', label: 'Success 600' },
  { id: 'bg-utility-success-950', value: '--utility-success-950', label: 'Success 950' },
  { id: 'bg-utility-success-900', value: '--utility-success-900', label: 'Success 900' },
  { id: 'bg-utility-success-800', value: '--utility-success-800', label: 'Success 800' },
  { id: 'bg-utility-success-700', value: '--utility-success-700', label: 'Success 700' },
  { id: 'bg-utility-success-500', value: '--utility-success-500', label: 'Success 500' },
  { id: 'bg-utility-success-400', value: '--utility-success-400', label: 'Success 400' },
  { id: 'bg-utility-success-300', value: '--utility-success-300', label: 'Success 300' },
  { id: 'bg-utility-success-200', value: '--utility-success-200', label: 'Success 200' },
  { id: 'bg-utility-success-100', value: '--utility-success-100', label: 'Success 100' },
  { id: 'bg-utility-success-50', value: '--utility-success-50', label: 'Success 50' },
  { id: 'bg-utility-success-25', value: '--utility-success-25', label: 'Success 25' },

  //error
  { id: 'bg-utility-error-600', value: '--utility-error-600', label: 'Error 600' },
  { id: 'bg-utility-error-950', value: '--utility-error-950', label: 'Error 950' },
  { id: 'bg-utility-error-900', value: '--utility-error-900', label: 'Error 900' },
  { id: 'bg-utility-error-800', value: '--utility-error-800', label: 'Error 800' },
  { id: 'bg-utility-error-700', value: '--utility-error-700', label: 'Error 700' },
  { id: 'bg-utility-error-500', value: '--utility-error-500', label: 'Error 500' },
  { id: 'bg-utility-error-400', value: '--utility-error-400', label: 'Error 400' },
  { id: 'bg-utility-error-300', value: '--utility-error-300', label: 'Error 300' },
  { id: 'bg-utility-error-200', value: '--utility-error-200', label: 'Error 200' },
  { id: 'bg-utility-error-100', value: '--utility-error-100', label: 'Error 100' },
  { id: 'bg-utility-error-50', value: '--utility-error-50', label: 'Error 50' },
  { id: 'bg-utility-error-25', value: '--utility-error-25', label: 'Error 25' },

  //warning
  { id: 'bg-utility-warning-600', value: '--utility-warning-600', label: 'Warning 600' },
  { id: 'bg-utility-warning-950', value: '--utility-warning-950', label: 'Warning 950' },
  { id: 'bg-utility-warning-900', value: '--utility-warning-900', label: 'Warning 900' },
  { id: 'bg-utility-warning-800', value: '--utility-warning-800', label: 'Warning 800' },
  { id: 'bg-utility-warning-700', value: '--utility-warning-700', label: 'Warning 700' },
  { id: 'bg-utility-warning-500', value: '--utility-warning-500', label: 'Warning 500' },
  { id: 'bg-utility-warning-400', value: '--utility-warning-400', label: 'Warning 400' },
  { id: 'bg-utility-warning-300', value: '--utility-warning-300', label: 'Warning 300' },
  { id: 'bg-utility-warning-200', value: '--utility-warning-200', label: 'Warning 200' },
  { id: 'bg-utility-warning-100', value: '--utility-warning-100', label: 'Warning 100' },
  { id: 'bg-utility-warning-50', value: '--utility-warning-50', label: 'Warning 50' },
  { id: 'bg-utility-warning-25', value: '--utility-warning-25', label: 'Warning 25' },
];

export const accentColors = [
  {
    id: 'bg-utility-lime-600',
    value: '--utility-lime-600',
    label: 'Lime Green 600',
  },
  {
    id: 'bg-utility-lime-950',
    value: '--utility-lime-950',
    label: 'Lime Green 950',
  },
  {
    id: 'bg-utility-lime-900',
    value: '--utility-lime-900',
    label: 'Lime Green 900',
  },
  {
    id: 'bg-utility-lime-800',
    value: '--utility-lime-800',
    label: 'Lime Green 800',
  },
  {
    id: 'bg-utility-lime-700',
    value: '--utility-lime-700',
    label: 'Lime Green 700',
  },
  {
    id: 'bg-utility-lime-500',
    value: '--utility-lime-500',
    label: 'Lime Green 500',
  },
  {
    id: 'bg-utility-lime-400',
    value: '--utility-lime-400',
    label: 'Lime Green 400',
  },
  {
    id: 'bg-utility-lime-300',
    value: '--utility-lime-300',
    label: 'Lime Green 300',
  },
  {
    id: 'bg-utility-lime-200',
    value: '--utility-lime-200',
    label: 'Lime Green 200',
  },
  {
    id: 'bg-utility-lime-100',
    value: '--utility-lime-100',
    label: 'Lime Green 100',
  },
  { id: 'bg-palette-lime-50', value: '--utility-lime-50', label: 'Lime Green 50' },
  { id: 'bg-utility-lime-25', value: '--utility-lime-25', label: 'Lime Green 25' },
  { id: 'bg-utility-teal-600', value: '--utility-teal-600', label: 'Teal 600' },
  { id: 'bg-utility-teal-950', value: '--utility-teal-950', label: 'Teal 950' },
  { id: 'bg-utility-teal-900', value: '--utility-teal-900', label: 'Teal 900' },
  { id: 'bg-utility-teal-800', value: '--utility-teal-800', label: 'Teal 800' },
  { id: 'bg-utility-teal-700', value: '--utility-teal-700', label: 'Teal 700' },
  { id: 'bg-utility-teal-500', value: '--utility-teal-500', label: 'Teal 500' },
  { id: 'bg-utility-teal-400', value: '--utility-teal-400', label: 'Teal 400' },
  { id: 'bg-utility-teal-300', value: '--utility-teal-300', label: 'Teal 300' },
  { id: 'bg-utility-teal-200', value: '--utility-teal-200', label: 'Teal 200' },
  { id: 'bg-utility-teal-100', value: '--utility-teal-100', label: 'Teal 100' },
  { id: 'bg-utility-teal-50', value: '--utility-teal-50', label: 'Teal 50' },
  { id: 'bg-utility-teal-25', value: '--utility-teal-25', label: 'Teal 25' },
  { id: 'bg-utility-cyan-600', value: '--utility-cyan-600', label: 'Cyan 600' },
  { id: 'bg-utility-cyan-950', value: '--utility-cyan-950', label: 'Cyan 950' },
  { id: 'bg-utility-cyan-900', value: '--utility-cyan-900', label: 'Cyan 900' },
  { id: 'bg-utility-cyan-800', value: '--utility-cyan-800', label: 'Cyan 800' },
  { id: 'bg-utility-cyan-700', value: '--utility-cyan-700', label: 'Cyan 700' },
  { id: 'bg-utility-cyan-500', value: '--utility-cyan-500', label: 'Cyan 500' },
  { id: 'bg-utility-cyan-400', value: '--utility-cyan-400', label: 'Cyan 400' },
  { id: 'bg-utility-cyan-300', value: '--utility-cyan-300', label: 'Cyan 300' },
  { id: 'bg-utility-cyan-200', value: '--utility-cyan-200', label: 'Cyan 200' },
  { id: 'bg-utility-cyan-100', value: '--utility-cyan-100', label: 'Cyan 100' },
  { id: 'bg-utility-cyan-50', value: '--utility-cyan-50', label: 'Cyan 50' },
  { id: 'bg-utility-cyan-25', value: '--utility-cyan-25', label: 'Cyan 25' },
  { id: 'bg-utility-blue-600', value: '--utility-blue-600', label: 'Blue 600' },
  { id: 'bg-utility-blue-950', value: '--utility-blue-950', label: 'Blue 950' },
  { id: 'bg-utility-blue-900', value: '--utility-blue-900', label: 'Blue 900' },
  { id: 'bg-utility-blue-800', value: '--utility-blue-800', label: 'Blue 800' },
  { id: 'bg-utility-blue-700', value: '--utility-blue-700', label: 'Blue 700' },
  { id: 'bg-utility-blue-500', value: '--utility-blue-500', label: 'Blue 500' },
  { id: 'bg-utility-blue-400', value: '--utility-blue-400', label: 'Blue 400' },
  { id: 'bg-utility-blue-300', value: '--utility-blue-300', label: 'Blue 300' },
  { id: 'bg-utility-blue-200', value: '--utility-blue-200', label: 'Blue 200' },
  { id: 'bg-utility-blue-100', value: '--utility-blue-100', label: 'Blue 100' },
  { id: 'bg-utility-blue-50', value: '--utility-blue-50', label: 'Blue 50' },
  { id: 'bg-utility-blue-25', value: '--utility-blue-25', label: 'Blue 25' },
  { id: 'bg-utility-blue-dark-600', value: '--utility-blue-dark-600', label: 'Dark Blue 600' },
  { id: 'bg-utility-blue-dark-950', value: '--utility-blue-dark-950', label: 'Dark Blue 950' },
  { id: 'bg-utility-blue-dark-900', value: '--utility-blue-dark-900', label: 'Dark Blue 900' },
  { id: 'bg-utility-blue-dark-800', value: '--utility-blue-dark-800', label: 'Dark Blue 800' },
  { id: 'bg-utility-blue-dark-700', value: '--utility-blue-dark-700', label: 'Dark Blue 700' },
  { id: 'bg-utility-blue-dark-500', value: '--utility-blue-dark-500', label: 'Dark Blue 500' },
  { id: 'bg-utility-blue-dark-400', value: '--utility-blue-dark-400', label: 'Dark Blue 400' },
  { id: 'bg-utility-blue-dark-300', value: '--utility-blue-dark-300', label: 'Dark Blue 300' },
  { id: 'bg-utility-blue-dark-200', value: '--utility-blue-dark-200', label: 'Dark Blue 200' },
  { id: 'bg-utility-blue-dark-100', value: '--utility-blue-dark-100', label: 'Dark Blue 100' },
  { id: 'bg-utility-blue-dark-50', value: '--utility-blue-dark-50', label: 'Dark Blue 50' },
  { id: 'bg-utility-blue-dark-25', value: '--utility-blue-dark-25', label: 'Dark Blue 25' },
  { id: 'bg-utility-indigo-600', value: '--utility-indigo-600', label: 'Indigo 600' },
  { id: 'bg-utility-indigo-950', value: '--utility-indigo-950', label: 'Indigo 950' },
  { id: 'bg-utility-indigo-900', value: '--utility-indigo-900', label: 'Indigo 900' },
  { id: 'bg-utility-indigo-800', value: '--utility-indigo-800', label: 'Indigo 800' },
  { id: 'bg-utility-indigo-700', value: '--utility-indigo-700', label: 'Indigo 700' },
  { id: 'bg-utility-indigo-500', value: '--utility-indigo-500', label: 'Indigo 500' },
  { id: 'bg-utility-indigo-400', value: '--utility-indigo-400', label: 'Indigo 400' },
  { id: 'bg-utility-indigo-300', value: '--utility-indigo-300', label: 'Indigo 300' },
  { id: 'bg-utility-indigo-200', value: '--utility-indigo-200', label: 'Indigo 200' },
  { id: 'bg-utility-indigo-100', value: '--utility-indigo-100', label: 'Indigo 100' },
  { id: 'bg-utility-indigo-50', value: '--utility-indigo-50', label: 'Indigo 50' },
  { id: 'bg-utility-indigo-25', value: '--utility-indigo-25', label: 'Indigo 25' },
  { id: 'bg-utility-violet-600', value: '--utility-violet-600', label: 'Violet 600' },
  { id: 'bg-utility-violet-950', value: '--utility-violet-950', label: 'Violet 950' },
  { id: 'bg-utility-violet-900', value: '--utility-violet-900', label: 'Violet 900' },
  { id: 'bg-utility-violet-800', value: '--utility-violet-800', label: 'Violet 800' },
  { id: 'bg-utility-violet-700', value: '--utility-violet-700', label: 'Violet 700' },
  { id: 'bg-utility-violet-500', value: '--utility-violet-500', label: 'Violet 500' },
  { id: 'bg-utility-violet-400', value: '--utility-violet-400', label: 'Violet 400' },
  { id: 'bg-utility-violet-300', value: '--utility-violet-300', label: 'Violet 300' },
  { id: 'bg-utility-violet-200', value: '--utility-violet-200', label: 'Violet 200' },
  { id: 'bg-utility-violet-100', value: '--utility-violet-100', label: 'Violet 100' },
  { id: 'bg-utility-violet-50', value: '--utility-violet-50', label: 'Violet 50' },
  { id: 'bg-utility-violet-25', value: '--utility-violet-25', label: 'Violet 25' },
  { id: 'bg-utility-fuchsia-600', value: '--utility-fuchsia-600', label: 'Fuchsia 600' },
  { id: 'bg-utility-fuchsia-950', value: '--utility-fuchsia-950', label: 'Fuchsia 950' },
  { id: 'bg-utility-fuchsia-900', value: '--utility-fuchsia-900', label: 'Fuchsia 900' },
  { id: 'bg-utility-fuchsia-800', value: '--utility-fuchsia-800', label: 'Fuchsia 800' },
  { id: 'bg-utility-fuchsia-700', value: '--utility-fuchsia-700', label: 'Fuchsia 700' },
  { id: 'bg-utility-fuchsia-500', value: '--utility-fuchsia-500', label: 'Fuchsia 500' },
  { id: 'bg-utility-fuchsia-400', value: '--utility-fuchsia-400', label: 'Fuchsia 400' },
  { id: 'bg-utility-fuchsia-300', value: '--utility-fuchsia-300', label: 'Fuchsia 300' },
  { id: 'bg-utility-fuchsia-200', value: '--utility-fuchsia-200', label: 'Fuchsia 200' },
  { id: 'bg-utility-fuchsia-100', value: '--utility-fuchsia-100', label: 'Fuchsia 100' },
  { id: 'bg-utility-fuchsia-50', value: '--utility-fuchsia-50', label: 'Fuchsia 50' },
  { id: 'bg-utility-fuchsia-25', value: '--utility-fuchsia-25', label: 'Fuchsia 25' },
  { id: 'bg-utility-pink-600', value: '--utility-pink-600', label: 'Pink 600' },
  { id: 'bg-utility-pink-950', value: '--utility-pink-950', label: 'Pink 950' },
  { id: 'bg-utility-pink-900', value: '--utility-pink-900', label: 'Pink 900' },
  { id: 'bg-utility-pink-800', value: '--utility-pink-800', label: 'Pink 800' },
  { id: 'bg-utility-pink-700', value: '--utility-pink-700', label: 'Pink 700' },
  { id: 'bg-utility-pink-500', value: '--utility-pink-500', label: 'Pink 500' },
  { id: 'bg-utility-pink-400', value: '--utility-pink-400', label: 'Pink 400' },
  { id: 'bg-utility-pink-300', value: '--utility-pink-300', label: 'Pink 300' },
  { id: 'bg-utility-pink-200', value: '--utility-pink-200', label: 'Pink 200' },
  { id: 'bg-utility-pink-100', value: '--utility-pink-100', label: 'Pink 100' },
  { id: 'bg-utility-pink-50', value: '--utility-pink-50', label: 'Pink 50' },
  { id: 'bg-utility-pink-25', value: '--utility-pink-25', label: 'Pink 25' },
  { id: 'bg-utility-rose-600', value: '--utility-rose-600', label: 'Rose 600' },
  { id: 'bg-utility-rose-950', value: '--utility-rose-950', label: 'Rose 950' },
  { id: 'bg-utility-rose-900', value: '--utility-rose-900', label: 'Rose 900' },
  { id: 'bg-utility-rose-800', value: '--utility-rose-800', label: 'Rose 800' },
  { id: 'bg-utility-rose-700', value: '--utility-rose-700', label: 'Rose 700' },
  { id: 'bg-utility-rose-500', value: '--utility-rose-500', label: 'Rose 500' },
  { id: 'bg-utility-rose-400', value: '--utility-rose-400', label: 'Rose 400' },
  { id: 'bg-utility-rose-300', value: '--utility-rose-300', label: 'Rose 300' },
  { id: 'bg-utility-rose-200', value: '--utility-rose-200', label: 'Rose 200' },
  { id: 'bg-utility-rose-100', value: '--utility-rose-100', label: 'Rose 100' },
  { id: 'bg-utility-rose-50', value: '--utility-rose-50', label: 'Rose 50' },
  { id: 'bg-utility-rose-25', value: '--utility-rose-25', label: 'Rose 25' },
  { id: 'bg-utility-orange-600', value: '--utility-orange-600', label: 'Orange 600' },
  { id: 'bg-utility-orange-950', value: '--utility-orange-950', label: 'Orange 950' },
  { id: 'bg-utility-orange-900', value: '--utility-orange-900', label: 'Orange 900' },
  { id: 'bg-utility-orange-800', value: '--utility-orange-800', label: 'Orange 800' },
  { id: 'bg-utility-orange-700', value: '--utility-orange-700', label: 'Orange 700' },
  { id: 'bg-utility-orange-500', value: '--utility-orange-500', label: 'Orange 500' },
  { id: 'bg-utility-orange-400', value: '--utility-orange-400', label: 'Orange 400' },
  { id: 'bg-utility-orange-300', value: '--utility-orange-300', label: 'Orange 300' },
  { id: 'bg-utility-orange-200', value: '--utility-orange-200', label: 'Orange 200' },
  { id: 'bg-utility-orange-100', value: '--utility-orange-100', label: 'Orange 100' },
  { id: 'bg-utility-orange-50', value: '--utility-orange-50', label: 'Orange 50' },
  { id: 'bg-utility-orange-25', value: '--utility-orange-25', label: 'Orange 25' },
];

export const backgroundColor = [
  ...whiteBlack.map((color) => ({ ...color, subGroupId: 'whiteBlack' })),
  ...primaryColor.map((color) => ({ ...color, subGroupId: 'primaryColor' })),
  ...accentColors.map((color) => ({ ...color, subGroupId: 'accentColor' })),
];

// Picker token id (Tailwind class) → CSS variable name. Not derivable by
// stripping `bg-`; semantic and palette tokens have different prefixes.
export const bgColorIdToCssVar: Record<string, string> = (() => {
  const lookup: Record<string, string> = {};
  for (const color of backgroundColor) {
    if (
      process.env.NODE_ENV !== 'production' &&
      color.id in lookup &&
      lookup[color.id] !== color.value
    ) {
      // eslint-disable-next-line no-console
      console.warn(
        `[bgColorIdToCssVar] duplicate id "${color.id}" with differing values ("${lookup[color.id]}" vs "${color.value}") — second occurrence wins.`,
      );
    }
    lookup[color.id] = color.value;
  }
  return lookup;
})();

export const gradientColor = [
  {
    id: 'gradient-brand',
    value: '--gradient-brand',
    label: 'Primary Brand',
  },
  {
    id: 'gradient-primary',
    value: '--gradient-primary',
    label: 'Primary Gradient',
  },
  {
    id: 'gradient-error',
    value: '--gradient-error',
    label: 'Error Gradient',
  },
  {
    id: 'gradient-warning',
    value: '--gradient-warning',
    label: 'Warning Gradient',
  },

  {
    id: 'gradient-success',
    value: '--gradient-success',
    label: 'Success Gradient',
  },
  {
    id: 'gradient-secondary',
    value: '--gradient-secondary',
    label: 'Secondary Gradient',
  },
  {
    id: 'gradient-tertiary',
    value: '--gradient-tertiary',
    label: 'Tertiary Gradient',
  },
  {
    id: 'gradient-neutral',
    value: '--gradient-neutral',
    label: 'Neutral Gradient',
  },
  {
    id: 'gradient-cool',
    value: '--gradient-cool',
    label: 'Cool Gradient',
  },
  {
    id: 'gradient-light',
    value: '--gradient-light',
    label: 'Light Gradient',
  },
  {
    id: 'gradient-blue',
    value: '--gradient-blue',
    label: 'Blue Gradient',
  },
  {
    id: 'gradient-yellow',
    value: '--gradient-yellow',
    label: 'Yellow Gradient',
  },
  {
    id: 'gradient-red',
    value: '--gradient-red',
    label: 'Red Gradient',
  },
  {
    id: 'bg-rainbow',
    value: '--gradient-rainbow',
    label: 'Rainbow Gradient',
  },
  {
    id: 'gradient-copilot-video-empty-state',
    value: '--gradient-copilot-video-empty-state',
    label: 'Copilot Video Empty State',
  },
  {
    id: 'gradient-copilot-video-empty-state-inactive',
    value: '--gradient-copilot-video-empty-state-inactive',
    label: 'Copilot Video Empty State Inactive',
  },
];

export const backgroundColorGroups: ColorGroups[] = [
  {
    id: 'backgroundColor',
    label: 'Solid',
    subGroups: [
      {
        id: 'whiteBlack',
        label: '',
        hideDivider: true,
        className: 'pb-xs',
      },
      {
        id: 'primaryColor',
        label: '',
      },
      {
        id: 'accentColor',
        label: '',
      },
    ],
    colors: backgroundColor,
  },
  {
    id: 'backgroundGradient',
    label: 'Gradients',
    colors: gradientColor,
  },
];
